(function () {
  function inclus() {
    document.querySelectorAll('[data-nsc-group][data-label="Finitions"] .nso-card__price').forEach(function (p) {
      if (p.textContent.trim() === 'Offert') p.textContent = 'Inclus';
    });
    document.querySelectorAll('[data-nsc-group][data-variants-picker][data-label="Nombre de roses"] .nso-numeral__n').forEach(function (n) {
      n.textContent = n.textContent.replace(/\s*roses?\s*$/i, '');
    });
  }
  function init() {
    inclus();
    document.querySelectorAll('[data-nsc-group][data-monogram="true"]').forEach(function (grp) {
      var lbl = (grp.getAttribute('data-label') || '').toLowerCase();
      var inp = grp.querySelector('input.nso-input');
      var digits = lbl.indexOf('chiffre') !== -1;
      var initials = lbl.indexOf('initiales') !== -1;
      if ((!digits && !initials) || !inp || inp.dataset.nsoDigits) return;
      inp.dataset.nsoDigits = '1';
      inp.maxLength = 2;
      if (digits) {
        inp.setAttribute('inputmode', 'numeric');
        inp.setAttribute('pattern', '[0-9]*');
        inp.setAttribute('placeholder', '0');
      } else {
        inp.setAttribute('autocapitalize', 'characters');
        inp.setAttribute('placeholder', 'AM');
      }
      var mono = grp.querySelector('[data-nso-mono]');
      function sync() {
        var v = digits ? inp.value.replace(/\D/g, '') : inp.value.replace(/[^A-Za-zÀ-ÿ]/g, '').toUpperCase();
        v = v.slice(0, 2);
        if (v !== inp.value) inp.value = v;
        if (mono) {
          var shown = v;
          if (initials && v.length === 2) shown = v.charAt(0) + '.' + v.charAt(1);
          mono.textContent = shown || '·';
          mono.style.fontSize = v.length > 1 ? '4rem' : '';
        }
      }
      ['input', 'change', 'keyup'].forEach(function (ev) {
        inp.addEventListener(ev, function () { sync(); setTimeout(sync, 0); setTimeout(sync, 60); });
      });
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  setTimeout(init, 800);
})();
